import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({ baseURL: `${BACKEND_URL}/api`, withCredentials: true });

export function errorMessage(error, fallback = "Une erreur est survenue. Réessayez dans quelques instants.") {
  const detail = error?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (detail && typeof detail.message === "string") return detail.message;
  if (Array.isArray(detail)) return "Certains champs sont invalides.";
  return fallback;
}

export const mediaUrl = (url) => (url && url.startsWith("/api/") ? `${BACKEND_URL}${url}` : url || null);

export function toQuery(params) {
  const sp = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (Array.isArray(value)) value.forEach((v) => sp.append(key, v));
    else if (value !== undefined && value !== null && value !== "") sp.append(key, value);
  });
  return sp.toString();
}
